export class Validacao {
    public id: number;
    public status: number;
    public justificativaIndeferimento: String;
    public tipoValidacao: number;
    public dataInclusao: Date;
    public dataEncerramento: Date;
    public usuario: number;
    public codigoInscricaoAluno: number;
}
